export default __webpack_public_path__ + "static/media/nefesh to achim.48c9e4f7.svg";